<template>
  <a :id="blok.anchor">
    <div ref="marker">
      <BasketList
        :empty-message="blok.empty_message"
        :highlight-duplicates="blok.highlight_duplicates"
        v-editable="blok"
      ></BasketList>
    </div>
  </a>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

import BasketList from '../../../components/cart/BasketList';

export default {
    name: 'basket-list',
    components: {
        BasketList
    },
    props: {
        blok: Object
    },
    computed: {
        ...mapGetters({
            item_ids: 'basket/item_ids'
        })
    },
    watch: {
        item_ids: function(n,o) {
            if(n!=o && this.$props.blok.scroll_into_view_on_change) {
                    this.$refs.marker.scrollIntoView({
                            behavior: "smooth",
                            blok: 'start'
                        });
            } 
        },
        'meal_preferences.shipping_date': function(v) {
            this.$bvToast.show('basket-getstarted');
        },
        'valid_voucher.code': function(n) {
            if(this.valid_voucher.price>0) {
                this.$bvToast.show('basket-voucher-verified');
            }
        }
    },
}
</script>
